export default __webpack_public_path__ + "static/media/no-product-image.236e0a1a.png";